import * as React from 'react';
import {
  SiApplepay,
  SiGooglepay,
  SiVisa,
  SiMastercard,
  SiAmericanexpress,
} from 'react-icons/si';

export default function PaymentOptions({ size }) {
  const iconSize = size || 28;
  return (
    <div className="flex justify-evenly items-center w-full text-white/80">
      <SiApplepay size={iconSize} />
      <SiGooglepay size={iconSize} />
      <SiVisa size={iconSize} />
      <SiMastercard size={iconSize} />
      <SiAmericanexpress size={iconSize} />
    </div>
  );
}
